import { AppContext } from "components/AppContext";
import React from "react";
import ErrorMessage from "./components/ErrorMessage";

const Error = payload => {
  const error = payload?.location?.state?.error;

  if (error && "response" in error) {
    const { data, status } = error.response;
    const errorMessage = () => {
      switch (status) {
        case 403:
          return "Looks like you don't have the permission to access the requested item.";

        default:
          return "Looks like something is broken";
      }
    };

    return <ErrorMessage message={errorMessage()} />;
  } else {
    return (
      <ErrorMessage
        message={
          " Looks like you don't have access. Please reach out to administrator. "
        }
      />
    );
  }
};

export default Error;
